import api from './http';

// Dossiers
export const getDossiers = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/dossiers${queryString ? `?${queryString}` : ''}`);
};
export const getDossier = (id) => api.get(`/dossiers/${id}`);
export const createDossier = (data) => api.post('/dossiers', data);
export const updateDossier = (id, data) => api.patch(`/dossiers/${id}`, data);
export const deleteDossier = (id) => api.delete(`/dossiers/${id}`);
export const exportDossiers = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/dossiers/export${queryString ? `?${queryString}` : ''}`, { responseType: 'blob' });
};
export const getDossierHistory = (id) => api.get(`/dossiers/${id}/history`);

// Checklists
export const getChecklistTemplate = (typeDossier) => api.get(`/checklists/template/${typeDossier}`);
export const updateChecklistItem = (dossierId, data) => api.patch(`/dossiers/${dossierId}/checklist`, data);
export const resetChecklist = (dossierId) => api.post(`/dossiers/${dossierId}/checklist/reset`);

// PDF Generation (devis/recu/attestation dossier)
export const generateDevisPdf = (dossierId) => api.get(`/pdf/devis/${dossierId}`, { responseType: 'blob' });
export const generateRecuPdf = (paymentId) => api.get(`/pdf/recu/${paymentId}`, { responseType: 'blob' });
export const generateAttestationPdf = (dossierId) => api.get(`/pdf/attestation/${dossierId}`, { responseType: 'blob' });

// Signature dossier
export const signDossier = (dossierId, data) => api.post(`/dossiers/${dossierId}/sign`, data);
export const getDossierSignatures = (dossierId) => api.get(`/dossiers/${dossierId}/signatures`);
